// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider-component{position:relative}.divider-component.divider-component--horizontal{display:block;width:100%;height:1px;margin:24px 0}.divider-component.divider-component--vertical{display:inline-block;width:1px;height:1em;margin:0 8px;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
